<mat-card class="pageWrapper">
    <!-- [cdkContextMenuTriggerFor]="createNew"
    <ng-template #createNew>
        <div class="create-menu" cdkMenu>
            <button class="create-menu-item" cdkMenuItem (click)="openCreateDialog('FOLDER')">New Folder</button>
            <button class="create-menu-item" cdkMenuItem (click)="openCreateDialog('DOCS')">Document</button>
            <button class="create-menu-item" cdkMenuItem (click)="openCreateDialog('SHEETS')">Spreadsheet</button>
            <button class="create-menu-item" cdkMenuItem (click)="openCreateDialog('SLIDES')">Presentation</button>
            <button class="create-menu-item" cdkMenuItem (click)="openCreateDialog('FORMS')">Form</button>
        </div>
    </ng-template> -->
    <mat-card-content>
        <div class="breadcrumb-link-wrap">
            <div class="breadcrumb-link-parent">
                <a [routerLink]="['/home']" class="breadcrumb-link">Home
                </a>
                <span *ngFor="let p of path; let indx = index">
                    <span class="breadcrumb-symbol"> > </span>
                    <a class="breadcrumb-link" (click)="openFolder(p, indx)">{{p.name}}
                    </a>
                </span>
            </div>
            <div class="create-upload-menu">
                <button mat-menu-item [matMenuTriggerFor]="create">
                    <mat-icon>add_circle</mat-icon>
                </button>
                <button mat-menu-item [matMenuTriggerFor]="upload">
                    <mat-icon>cloud_upload</mat-icon>
                </button>
            </div>
            <mat-menu #create="matMenu" class="create-menu">
                <button mat-menu-item class="create-menu-item" (click)="openCreateDialog('FOLDER')">
                    <span>New Folder</span>
                </button>
                <button mat-menu-item class="create-menu-item" (click)="openCreateDialog('DOCS')">
                    <span>Document</span>
                </button>
                <button mat-menu-item class="create-menu-item" (click)="openCreateDialog('SHEETS')">
                    <span>Spreadsheet</span>
                </button>
                <button mat-menu-item class="create-menu-item" (click)="openCreateDialog('SLIDES')">
                    <span>Slide</span>
                </button>
                <button mat-menu-item class="create-menu-item" (click)="openCreateDialog('FORMS')">
                    <span>Form</span>
                </button>
            </mat-menu>
            <mat-menu #upload="matMenu" class="create-menu">
                <button mat-menu-item class="create-menu-item" (click)="openUploadDialog('file')">
                    <span>Upload File</span>
                </button>
                <button mat-menu-item class="create-menu-item" (click)="openUploadDialog('folder')">
                    <span>Upload Folder</span>
                </button>
            </mat-menu>
        </div>
        <mat-form-field class="fullWidth" appearance="outline">
            <mat-label>Filter</mat-label>
            <input matInput (keyup)="applyFilter($event)" #input>
        </mat-form-field>
        <div class="list-grid-wrap home">
            <span class="list-icon" (click)="setViewStatus('list')" matTooltip="List View">
                <mat-icon>list</mat-icon>
            </span>
            <span class="grid-icon" (click)="setViewStatus('grid')" matTooltip="Grid View">
                <mat-icon>grid_view</mat-icon>
            </span>
            <span class="sort-icon" (click)="sortNamesAsc()" *ngIf="!ascSorted" matTooltip="Sort">
                <mat-icon>arrow_upward</mat-icon>
            </span>
            <span class="sort-icon" (click)="sortNamesDesc()" *ngIf="!descSorted" matTooltip="Sort">
                <mat-icon>arrow_downward</mat-icon>
            </span>
        </div>
        <div class="section-wrap" *ngIf="!isLoading">
            <div *ngIf="allFoldersFiltered.length != 0 && isLoading == false; else nofilesOrFolder">
                <mat-grid-list [cols]="isMobile ? 1 : 4" rowHeight="200px" gutterSize="30px" *ngIf="isStatusGrid">
                    <mat-grid-tile *ngFor="let folder of allFoldersFiltered" (click)="openFolder(folder)" style="cursor: pointer;">
                        <div class="menuHome"
                            *ngIf="folder.mimeType == 'application/vnd.google-apps.folder';else filesContent">
                            <div class="folder-icon">
                                <mat-icon>folder</mat-icon>
                            </div>
                            <div class="tileText">
                                {{folder.name}}
                            </div>
                        </div>
                        <ng-template #filesContent>
                            <a href="{{folder.driveLink}}" target="_blank">
                                <div class="menuHome">
                                    <div
                                        *ngIf="folder.mimeType.includes('google-apps.document') || folder.mimeType.includes('word'); else excelImage">
                                        <img src=" ../../assets/google-doc-logo.png">
                                    </div>
                                    <ng-template #excelImage>
                                        <div
                                            *ngIf="folder.mimeType.includes('excel')  || folder.mimeType.includes('sheet'); else formImage">
                                            <img src="../../assets/google-sheet-logo.png">
                                        </div>
                                    </ng-template>
                                    <ng-template #formImage>
                                        <div
                                            *ngIf="folder.mimeType == 'application/vnd.google-apps.form'; else slideImage">
                                            <img src="../../assets/google-form-logo.png">
                                        </div>
                                    </ng-template>
                                    <ng-template #slideImage>
                                        <div *ngIf="folder.mimeType.includes('presentation'); else pdfImage">
                                            <img src="../../assets/google-slide-logo.png">
                                        </div>
                                    </ng-template>
                                    <ng-template #pdfImage>
                                        <div *ngIf="folder.mimeType.includes('pdf'); else galleryImage">
                                            <img src="../../assets/file-pdf.svg">
                                        </div>
                                    </ng-template>
                                    <ng-template #galleryImage>
                                        <div
                                            *ngIf="folder.mimeType.includes('png') || folder.mimeType.includes('jpg') || folder.mimeType.includes('jpeg') || folder.mimeType.includes('svg'); else otherFiles">
                                            <img src="../../assets/images.png">
                                        </div>
                                    </ng-template>
                                    <ng-template #otherFiles>
                                        <div>
                                            <mat-icon>description</mat-icon>
                                        </div>
                                    </ng-template>
                                    <div class="tileText">
                                        {{folder.name}}
                                    </div>
                                </div>
                            </a>
                        </ng-template>
                    </mat-grid-tile>
                </mat-grid-list>
                <mat-list *ngIf="!isStatusGrid" matSort>
                    <mat-list-item *ngFor="let folder of allFoldersFiltered" class="listHome">
                        <ng-container
                            *ngIf="folder.mimeType == 'application/vnd.google-apps.folder';else shortCutContent">
                            <span (click)="openFolder(folder)">
                                <mat-icon matListItemIcon class="folder-icon">folder</mat-icon>
                                <div matListItemTitle class="tileText">{{folder.name}}</div>
                            </span>
                        </ng-container>
                        <ng-template #shortCutContent>
                            <span (click)="shortcutFile()"
                                *ngIf="folder.mimeType == 'application/vnd.google-apps.shortcut';else filesContentList">
                                <mat-icon matListItemIcon><img src=" ../../assets/folder.png"></mat-icon>
                                <div matListItemTitle class="tileText">{{folder.name}}</div>
                            </span>
                        </ng-template>
                        <ng-template #filesContentList>
                            <a href="{{folder.driveLink}}" target="_blank">
                                <mat-icon matListItemIcon
                                    *ngIf="folder.mimeType.includes('google-apps.document') || folder.mimeType.includes('word'); else excelImage">
                                    <img src=" ../../assets/google-doc-logo.png">
                                </mat-icon>
                                <ng-template #excelImage>
                                    <mat-icon matListItemIcon
                                        *ngIf="folder.mimeType.includes('excel')  || folder.mimeType.includes('sheet'); else formImage">
                                        <img src="../../assets/google-sheet-logo.png">
                                    </mat-icon>
                                </ng-template>
                                <ng-template #formImage>
                                    <mat-icon matListItemIcon
                                        *ngIf="folder.mimeType == 'application/vnd.google-apps.form'; else slideImage">
                                        <img src="../../assets/google-form-logo.png">
                                    </mat-icon>
                                </ng-template>
                                <ng-template #slideImage>
                                    <mat-icon matListItemIcon
                                        *ngIf="folder.mimeType.includes('presentation'); else pdfImage">
                                        <img src="../../assets/google-slide-logo.png">
                                    </mat-icon>
                                </ng-template>
                                <ng-template #pdfImage>
                                    <mat-icon matListItemIcon
                                        *ngIf="folder.mimeType.includes('pdf'); else galleryImage">
                                        <img src="../../assets/file-pdf.svg">
                                    </mat-icon>
                                </ng-template>
                                <ng-template #galleryImage>
                                    <mat-icon matListItemIcon
                                        *ngIf="folder.mimeType.includes('png') || folder.mimeType.includes('jpg') || folder.mimeType.includes('jpeg') || folder.mimeType.includes('svg'); else otherFiles">
                                        <img src="../../assets/images.png">
                                    </mat-icon>
                                </ng-template>
                                <ng-template #otherFiles>
                                    <mat-icon matListItemIcon>description</mat-icon>
                                </ng-template>
                                <span matListItemTitle class="tileText">{{folder.name}}</span>
                            </a>
                        </ng-template>
                    </mat-list-item>
                </mat-list>
            </div>
            <ng-template #nofilesOrFolder>
                There are no files or folders in this folder.
            </ng-template>
        </div>
    </mat-card-content>
</mat-card>